import router from './router'
import store from './store'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { notification } from 'ant-design-vue'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN, SET_PAGE } from '@/store/mutation-types'
import { i18nRender } from '@/locales'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const allowList = ['login', 'register', 'registerResult', 'myhome', 'user', 'privacy'] // no redirect allowList
const loginRoutePath = '/user/login'
const defaultRoutePath = '/dashboard/welcome'
router.beforeEach((to, from, next) => {
  console.log(to,from,'====================')
  if (to.name == 'login') {
    if (to.query.t) {
      window.localStorage.setItem('ot', to.query.t)
      // storage.set(ACCESS_TOKEN, to.query.t, 12 * 60 * 60 * 1000)
    } else {
      window.localStorage.removeItem('ot')
      window.sessionStorage.removeItem('ot')
    }
  } else if (to.query.token) {
    storage.set(ACCESS_TOKEN, to.query.token, 12 * 60 * 60 * 1000)
    //如果page==true进入培训中心，保存page字段
    if (to.query.page) {
      storage.set(SET_PAGE, to.query.page)
      // console.log( storage.get(SET_PAGE),'store.getters.page==============')
    }
  }
  to.meta && typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`)
  NProgress.start()
  if (storage.get(ACCESS_TOKEN)) {
    // 已登录且要跳转的页面是登录页
    if (to.path === loginRoutePath) {
      next({
        path: 'dashboard'
      })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch('GetInfo')
          .then(() => {
            // 调用 vuex 的 从后端获取用户的路由菜单，动态添加可访问路由表
            store.dispatch('GenerateRoutes').then(() => {
              // 把已获取到的路由菜单加入到路由表中
              console.log(
                store.getters.addRouters,
                'store.getters.addRoutersstore.getters.addRoutersstore.getters.addRouters'
              )
              router.addRoutes(store.getters.addRouters)
              console.log(router, 'routerrouterrouterrouterrouterrouterrouterrouter')
              console.log(router.options.routes)
              console.log(
                to,
                store.getters.roles,
                storage.get(SET_PAGE),
                store.getters.roles.includes(117),
                store.getters.roles.includes(120),
                'store.getters.roles.================='
              )
              //是否访问培训中心
              if (storage.get(SET_PAGE)) {
                //判断用户权限培训管理员or培训员工
                if (store.getters.roles.includes(117)) {
                  console.log(to, 'to======================')
                  // to.path = '/training/mycourse/list'
                return  next({
                    path: '/training/mangement/list/list'
                  })
                } else if (store.getters.roles.includes(120)) {
                  // to.path = '/training/mycourse/list'
                 return next({
                    path: '/training/mycourse/list'
                  })
                }
              }
              const redirect = decodeURIComponent(from.query.redirect || to.path)
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({
                  ...to,
                  replace: true
                })
              } else {
                // 跳转到目的路由
                next({
                  path: redirect
                })
              }
            })
          })
          .catch(() => {
            notification.error({
              message: '错误',
              description: '请求用户信息失败，请重试'
            })
            store.dispatch('Logout').then(() => {
              // window.localStorage.removeItem('ot')
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          })
        // 登录时未拉取 菜单，在此处拉取
      } else {
        store.getters.roles
        next()
      }
    }
  } else {
    /* has no token*/
    if (allowList.indexOf(to.name) !== -1) {
      // 在免登录白名单，直接进入
      console.log(to)
      next()
    } else {
      const redirect = decodeURIComponent(from.query.redirect || to.path)
      next(`user/login`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.name == 'login') {
//     if (to.query.t) {
//       window.localStorage.setItem('ot', to.query.t)
//     }
//   }
//   console.log(from,to)
//   NProgress.start() // start progress bar
//   to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`))
//   if (storage.get(ACCESS_TOKEN)) {
//     console.log(11111111111111111111111111111111111111111111111111111111111111)
//     /* has token */
//     if (to.path === loginRoutePath) {
//       next({
//         name: 'dashboard'
//       })
//       NProgress.done()
//     } else {
//       if (store.getters.roles.length === 0) {
//         store.dispatch('GetInfo')
//           .then(() => {
//             // 调用 vuex 的 从后端获取用户的路由菜单，动态添加可访问路由表
//             store.dispatch('GenerateRoutes').then(() => {
//               // 把已获取到的路由菜单加入到路由表中
//               router.addRoutes(store.getters.addRouters)
//               const redirect = decodeURIComponent(from.query.redirect || to.path)
//               if (to.path === redirect) {
//                 // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//                 next({
//                   ...to,
//                   replace: true
//                 })
//               } else {
//                 // 跳转到目的路由
//                 next({
//                   path: redirect
//                 })
//               }
//             })
//           })
//           .catch(() => {
//             notification.error({
//               message: '错误',
//               description: '请求用户信息失败，请重试'
//             })
//             store.dispatch('Logout').then(() => {
//               // window.localStorage.removeItem('ot')
//               console.log('‘退出删除token')
//               next({
//                 path: loginRoutePath,
//               })
//               NProgress.done()
//             })

//           })
//       } else {
//         next()
//         NProgress.done()
//       }
//     }
//   } else {

//     console.log(22222222222222222222222222222222222222222222)
//     if (allowList.includes(to.name)) {
//       console.log('to.name', to.name)
//       console.log("免密白名单")
//       // 在免登录白名单，直接进入
//       next()
//     } else {
//       console.log('跳转登录页')
//       // next()
//       next({
//         path: loginRoutePath,

//       })
//       NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
//     }
//   }
// })

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
